// import { isJwtExpired } from 'jwt-check-expiration'

export function authHeader() {
  // return authorization header with jwt token
  let token = localStorage.getItem("auth_token")
  // let tokenExpired = false
  // if(token)
  //   tokenExpired = isJwtExpired(token)
  // console.log(tokenExpired)

  if (token) {
    // console.log("token found")
    return { Authorization:
      "Bearer " + token
    }
  } else {
    // console.log('no token available')
    return {}
  }
}
